import React from 'react';
import styles from './Process.module.css';

const Process = ({ data }) => {
  if (!data) return null;
  return (
    <section id="process" className={`${styles.processSection} section`}>
      <div className="container">
        <h2 className="section-title fade-in">{data.title}</h2>
        <ol className={`${styles.processGrid} fade-in`}>
          {data.steps?.map((step) => (
            <li key={step.number} className={styles.processCard}>
              <div className={styles.stepNumber}>{step.number}</div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDescription}>{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Process;


